import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import moment from 'moment';
import {
	showDownloadedMaps,
	hideDownloadedMaps,
	showDownloadedMap,
	hideDownloadedMap,
	removeDownloadedMap,
	toggleShowDownloadedMapMarkers,
	push
} from 'actions';

const DownloadedListStyle = {
    title: {
    	display: 'inline-block'
    },
    date : {
    	display: 'inline-block',
    	paddingLeft : '5px'
    },
    listItem : {
        background: '#1D2127',
        borderRadius: '4px',
        marginBottom: ' 3px',
        display : 'block',
        padding: '4px 8px',
        color: '#bbbbbb',
        cursor: 'pointer'
    },
    controls : {
        display : 'block',
        float : 'right',
        marginLeft : '5px'
    },
    list : {
        margin: '10px',
        padding: '4px',
        maxWidth : '100%'
    },
    btnGroup : {
        margin: '-4px -8px -4px 0',
        borderTopLeftRadius : '0px',
        borderBottomLeftRadius : '0px',
        borderLeft : '3px solid #414A58'
    },
    btn : {
        borderTopLeftRadius : '0px',
        borderBottomLeftRadius : '0px',
    },
    showBtn : {
    	padding : '3px 5px',
    	float: 'right',
    	marginRight : '14px'
    }
};

class DownloadedMapList extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'DownloadedMapList';

        this.overMap = null;
        this.overElem = null;

        this.hideMap = this.hideMap.bind(this);
        this.showMap = this.showMap.bind(this);
				this.zoomMap = this.zoomMap.bind(this);
        this.removeMap = this.removeMap.bind(this);
        this.showMaps = this.showMaps.bind(this);
        this.showMapInfo = this.showMapInfo.bind(this);
        this.mapClick = this.mapClick.bind(this);
    }
    hideMap(map) {
    	this.props.dispatch(hideDownloadedMap(map.id));
    }
    showMap(map) {
    	this.props.dispatch(showDownloadedMap(map.id));
    }
		zoomMap(map) {
			if(this.props.onMapZoom) {
				this.props.onMapZoom(map);
			}
		}
    removeMap(map) {
			const { pathname } = this.props.routing.locationBeforeTransitions;
			const path_array = pathname.split('/').filter(e => e != '');
			if(path_array[path_array.length - 1] == map.id) {
				this.props.dispatch(push('clients/map'));
			}
    	this.props.dispatch(removeDownloadedMap(map.id));
    }
    showMaps(bool) {
    	if(bool)
	    	this.props.dispatch(showDownloadedMaps());
	    else
	    	this.props.dispatch(hideDownloadedMaps());
    }
    showMapInfo(map) {
    	if(this.props.showMapInfo)
    		this.props.showMapInfo(map)
    }
    mapClick(map) {
    	if(this.props.onMapClick)
    		this.props.onMapClick(map)
    }
    render() {
    	var {downloaded_maps, show_downloaded_maps} = this.props;
    	if(show_downloaded_maps)
    		DownloadedListStyle.list.display = 'block';
    	else
    		DownloadedListStyle.list.display = 'none';

        if(downloaded_maps && downloaded_maps.length > 0) {
          return(
          	<div>
              <ul style={DownloadedListStyle.list} >
                {downloaded_maps.map((map,index) => {
                  return (
										<li key={index} onDoubleClick={e => this.mapClick(map)} style={DownloadedListStyle.listItem} className='clearfix'>
                      <span style={DownloadedListStyle.title}>{map.map.properties.title}</span>
                      <span style={DownloadedListStyle.date}>{moment(map.map.properties.storm_date.slice(0,10)).format('MM/DD/YYYY')}</span>
                      <span style={DownloadedListStyle.controls}>
                        <span className='btn-group' style={DownloadedListStyle.btnGroup}>
													{map.map.features.find(f => f.geometry.type == 'Point') ? (
														<span
															onClick={() => this.props.dispatch(toggleShowDownloadedMapMarkers(map.id))}
															className={`btn btn-${map.markers_visible ? 'primary' : 'warning'}`}
															style={DownloadedListStyle.btn}
															>
															<i className='fa fa-map-marker' />
														</span>
													) : null}
	                        {(()=>{
	                        	if(map.visible) {
															return (
																<span
																	onClick={e => this.hideMap(map)}
																	className='btn btn-primary'
																	style={DownloadedListStyle.btn}
																	>
																	<i className='fa fa-eye' />
																</span>
															)
														}
	                        	else {
															return (
																<span
																	onClick={e => this.showMap(map)}
																	className='btn btn-warning'
																	style={DownloadedListStyle.btn}
																	>
																	<i className='fa fa-eye-slash' />
																</span>
															)
														}
	                        })()}
													<span
														onClick={e => this.zoomMap(map)}
														className='btn btn-info'
														style={DownloadedListStyle.btn}
														>
														<i className='fa fa-search-plus' />
													</span>
                          <span
														onClick={e => this.removeMap(map)}
														className='btn btn-danger'>
														<i className='fa fa-minus' />
													</span>
                        </span>
                      </span>
                    </li>
									)
                })}
              </ul>
              {(()=>{
              	if(show_downloaded_maps)
              		return <div onClick={e => this.showMaps(false)} title='Hide Downloaded Maps' style={DownloadedListStyle.showBtn} className='btn btn-default'><i className='fa fa-map-o'></i></div>
              	else
              		return <div onClick={e => this.showMaps(true)} title='Show Downloaded Maps' style={DownloadedListStyle.showBtn} className='btn btn-info'><i className='fa fa-map'></i></div>
              })()}
            </div>
          )
        }
	    else
	    	return (<div></div>)

    }
}

DownloadedMapList.propTypes = {
	showMapInfo : PropTypes.func,
	onMapClick : PropTypes.func
}

const mapStateToProps = ({map_search, routing}) => {
	return {
		...map_search,
		routing
	}
}
export default connect(mapStateToProps)(DownloadedMapList);



// WEBPACK FOOTER //
// ./src/browser/components/maps/downloadedMapsList.js